import { useEffect, useState } from 'react'
import { api, type PlaylistSummary } from '../lib/api'
import { useStaffText } from '../ui/StaffText'
import { StudioSelect } from './heroParts'
import type { LayoutMedia } from './types'

/** Where a media area's items come from: a saved playlist (none is campaigns only), or its own list. */
export function MediaSource({ media, onChange }: { media: LayoutMedia; onChange: (media: LayoutMedia) => void }) {
  const { say } = useStaffText()
  const [playlists, setPlaylists] = useState<PlaylistSummary[]>([])
  useEffect(() => {
    api
      .designPlaylists()
      .then((r) => setPlaylists(r.playlists))
      .catch(() => setPlaylists([]))
  }, [])
  const saved = media.source === 'playlist'
  return (
    <div className="studio-media">
      <StudioSelect
          label={say('signage.source')}
          value={saved ? 'playlist' : 'own'}
          onChange={(v) => onChange(v === 'playlist' ? { items: [], source: 'playlist' } : { items: [], source: 'own' })}
          options={[
            { value: 'playlist', label: say('signage.source.playlist') },
            { value: 'own', label: say('signage.source.own') },
          ]}
        />
      {saved && (
          <StudioSelect
            label={say('signage.playlist')}
            value={media.playlistId ?? ''}
            onChange={(id) => onChange({ items: [], source: 'playlist', ...(id ? { playlistId: id } : {}) })}
            options={[
              { value: '', label: say('signage.source.campaignsOnly') },
              ...playlists.map((p) => ({ value: p.id, label: p.name })),
            ]}
          />
      )}
    </div>
  )
}
